export default {
  // 共通項目
  'pages.app.common.appId': 'アプリID',
  'pages.app.common.appName': 'アプリ名',
  'pages.app.common.description': '説明',
  'pages.app.common.type': 'タイプ',
  'pages.app.common.order': '表示順',
  'pages.app.common.status': 'ステータス',
  'pages.app.common.operation': '操作',
  'pages.app.common.company': '会社',
  'pages.app.common.department': '部門',
  'pages.app.common.role': 'ロール',
  'pages.app.common.user': 'ユーザー',
  'pages.app.common.createTime': '作成日時',
  'pages.app.common.updateTime': '更新日時',
  'pages.app.common.creator': '作成者',
  'pages.app.common.updater': '更新者',
  'pages.app.common.enabled': '有効',
  'pages.app.common.disabled': '無効',
  'pages.app.common.enabledIn': '有効中',
  'pages.app.common.disabledIn': '停止中',
  'pages.app.common.disabledDone': '停止済み',
  'pages.app.common.noDescription': '説明なし',
  'pages.app.common.notAvailable': 'N/A',
  'pages.app.common.other': 'その他',
  'pages.app.common.all': 'すべて',
  'pages.app.common.chat': 'チャット',
  'pages.app.common.search': '検索',
  'pages.app.common.memory': 'メモリ',
  'pages.app.common.agent': 'エージェント',
  'pages.app.common.more': 'もっと見る',
  'pages.app.common.collapse': '折りたたむ',
  'pages.app.common.searchPlaceholder': '入力してください',
  'pages.app.common.keywordPlaceholder': 'キーワードを入力',
  'pages.app.common.filterCondition': '絞り込み条件',
  'pages.app.common.icon': 'アイコン',
  'pages.app.common.total': '総件数',
  'pages.app.common.export': 'エクスポート',
  'pages.app.common.print': '印刷',
  'pages.app.common.exportOptionExcel': 'Excel (.xlsx)',
  'pages.app.common.exportOptionCsv': 'CSV (.csv)',
  'pages.app.common.exportOptionPdf': 'PDF (.pdf)',

  // マイアプリ
  'pages.app.mine.title': 'マイアプリ',
  'pages.app.mine.unionQuery': '統合検索',
  'pages.app.mine.fetchListFailed': 'アプリ一覧の取得に失敗しました',
  'pages.app.mine.noDescription': '説明はありません',
  'pages.app.exportOptionExcel': 'Excel (.xlsx)',
  'pages.app.exportOptionCsv': 'CSV (.csv)',
  'pages.app.exportOptionPdf': 'PDF (.pdf)',

  // アクション
  'pages.app.action.edit': '編集',
  'pages.app.action.config': '設定',
  'pages.app.action.enable': '有効化',
  'pages.app.action.disable': '無効化',
  'pages.app.action.export': 'エクスポート',
  'pages.app.action.create': '新規作成',

  // アプリ管理
  'pages.app.mgmt.list.title': 'アプリ管理',
  'pages.app.mgmt.list.reportTitle': 'アプリ一覧',
  'pages.app.mgmt.list.reportDataTitle': 'アプリデータ',
  'pages.app.mgmt.list.unionQuery': '複合検索',
  'pages.app.mgmt.list.appType': 'アプリタイプ',
  'pages.app.mgmt.list.appTypePlaceholder': 'タイプを選択または入力',
  'pages.app.mgmt.list.totalApps': '総アプリ数',
  'pages.app.mgmt.list.summary': '全 {count} 件',
  'pages.app.mgmt.list.exportNoData': 'エクスポートするデータがありません',
  'pages.app.mgmt.list.exportSuccess': 'エクスポートに成功しました',
  'pages.app.mgmt.list.exportFailed': 'エクスポートに失敗しました',
  'pages.app.mgmt.list.toggleSuccess': '操作が成功しました',
  'pages.app.mgmt.list.toggleFailed': '操作に失敗しました',
  'pages.app.mgmt.list.confirmTitle': '操作の確認',
  'pages.app.mgmt.list.confirmDisable': 'このアプリを無効にしてもよろしいですか？',
  'pages.app.mgmt.list.confirmEnable': 'このアプリを有効にしてもよろしいですか？',

  // 詳細・編集・作成
  'pages.app.detail.title': 'アプリ詳細',
  'pages.app.detail.edit': '編集',
  'pages.app.detail.backList': '一覧に戻る',
  'pages.app.detail.fetchFailed': '詳細情報の取得に失敗しました',
  'pages.app.detail.appIcon': 'アプリ画像',
  'pages.app.detail.basicInfo': '基本情報',
  'pages.app.detail.accessControl': 'アクセス制御',
  'pages.app.detail.description': 'アプリの説明',
  'pages.app.detail.company': '所属会社',
  'pages.app.detail.department': '所属部門',
  'pages.app.detail.role': '対象ロール',
  'pages.app.detail.user': '所有ユーザー',
  'pages.app.create.title': 'アプリ作成',
  'pages.app.edit.title': 'アプリ編集',

  // フォーム項目
  'pages.app.form.appName.label': 'アプリ名',
  'pages.app.form.appName.placeholder': 'アプリ名を入力してください',
  'pages.app.form.appName.required': 'アプリ名を入力してください',
  'pages.app.form.appIcon.label': 'アプリ画像',
  'pages.app.form.appType.label': 'アプリタイプ',
  'pages.app.form.appType.placeholder': 'タイプを選択',
  'pages.app.form.appType.required': 'タイプを選択してください',
  'pages.app.form.description.label': 'アプリ説明',
  'pages.app.form.description.placeholder': 'アプリの概要を入力してください',
  'pages.app.form.order.label': '表示順',
  'pages.app.form.order.placeholder': '順序番号を入力',
  'pages.app.form.order.required': '表示順を入力してください',
  'pages.app.form.status.label': 'ステータス',
  'pages.app.form.status.placeholder': 'ステータスを選択',
  'pages.app.form.status.required': 'ステータスを選択してください',
  'pages.app.form.status.enabled': '有効',
  'pages.app.form.status.disabled': '無効',
  'pages.app.form.company.label': '所属会社',
  'pages.app.form.company.placeholder': '会社を選択してください',
  'pages.app.form.department.label': '所属部門',
  'pages.app.form.department.placeholder': '部門を選択してください',
  'pages.app.form.role.label': '対象ロール',
  'pages.app.form.role.placeholder': 'ロールを選択してください',
  'pages.app.form.user.label': '対象ユーザー',
  'pages.app.form.user.placeholder': 'ユーザーを選択してください',
  'pages.app.form.keywordPlaceholder': 'キーワードを入力',

  // 作成ウィザード
  'pages.app.create.method.label': '作成方法',
  'pages.app.create.method.required': '作成方法を選択してください',
  'pages.app.create.method.blank': '新規作成',
  'pages.app.create.method.template': 'テンプレートから作成',
  'pages.app.create.method.import': 'JSONファイルをインポート',
  'pages.app.create.agentType.label': 'エージェントタイプ',
  'pages.app.create.agentType.required': 'タイプを選択してください',
  'pages.app.create.agentType.flow': 'エージェントフロー',
  'pages.app.create.agentType.pipeline': '取り込みパイプライン',
  'pages.app.create.template.label': 'テンプレート選択',
  'pages.app.create.template.placeholder': 'テンプレートを選択してください',
  'pages.app.create.template.required': 'テンプレートを選択してください',
  'pages.app.create.dsl.label': 'DSLファイル',
  'pages.app.create.dsl.selectFile': 'JSONファイルを選択',
  'pages.app.create.dsl.selected': '選択済み：{name}',
  'pages.app.create.dsl.empty': 'DSLファイルの内容が空です',
  'pages.app.create.dsl.invalidGraph': 'DSLファイルに有効なノードデータ（graph.nodes）がありません',
  'pages.app.create.dsl.invalidJson': 'ファイルの形式が正しいJSONではありません',
  'pages.app.create.error.selectTemplate': 'テンプレートを選択してください',
  'pages.app.create.error.templateNotFound': 'テンプレートデータが見つかりません。再度選択してください',
  'pages.app.create.error.selectDslFile': 'DSLのJSONファイルを選択してください',
  'pages.app.create.error.selectCreateMethod': '作成方法を選択してください',
  'pages.app.create.error.appTypeInvalid': 'アプリタイプが無効です',
  'pages.app.create.error.createFailed': '作成に失敗しました',
  'pages.app.create.error.createAgentFailed': 'エージェントの作成に失敗しました',
  'pages.app.create.error.fetchGlobalConfigFailed': 'グローバル設定の取得に失敗しました',
  'pages.app.create.success': '作成が完了しました',
  'pages.app.edit.error.fetchFailed': '情報の取得に失敗しました',
  'pages.app.edit.error.updateFailed': '更新に失敗しました',
  'pages.app.edit.error.updateAgentFailed': 'エージェントの更新に失敗しました',
  'pages.app.edit.success': '更新が完了しました',

  // 分析
  'pages.app.analysis.company': '会社',
  'pages.app.analysis.date': '日付',
  'pages.app.analysis.appName': 'アプリ名',
  'pages.app.analysis.userCount': '利用者数',
  'pages.app.analysis.tokenUsed': 'トークン消費量',
  'pages.app.analysis.appCount': 'アプリ数',
  'pages.app.analysis.appFilterLabel': 'アプリ',
  'pages.app.analysis.appFilterPlaceholder': 'アプリを選択',
  'pages.app.analysis.tab.usage': '利用者数',
  'pages.app.analysis.tab.token': 'トークン消費量',
  'pages.app.analysis.tab.count': 'アプリ数',
  'pages.app.analysis.rank.app': 'アプリ',
  'pages.app.analysis.rank.company': '会社',
  'pages.app.analysis.rank.user': 'ユーザー',
  'pages.app.analysis.quick.today': '今日',
  'pages.app.analysis.quick.week': '今週',
  'pages.app.analysis.quick.month': '今月',
  'pages.app.analysis.quick.year': '今年',
  'pages.app.analysis.query.hourly': '時間単位',
  'pages.app.analysis.query.daily': '日単位',
  'pages.app.analysis.query.weekly': '週単位',
  'pages.app.analysis.query.monthly': '月単位',
  'pages.app.analysis.chart.usageTrend': '利用者数推移',
  'pages.app.analysis.chart.tokenTrend': 'トークン消費推移',
  'pages.app.analysis.chart.countTrend': 'アプリ数推移',
  'pages.app.analysis.rank.usage': '利用者数ランキング',
  'pages.app.analysis.rank.token': 'トークン消費ランキング',
  'pages.app.analysis.metric.usage': '利用者数',
  'pages.app.analysis.metric.token': 'トークン消費量',
  'pages.app.analysis.metric.count': 'アプリ数',

  // 設定
  'pages.app.config.updateSuccess': '更新しました',
  'pages.app.config.updateFailed': '更新に失敗しました',
  'pages.app.config.deleteSuccess': '削除しました',
  'pages.app.config.deleteFailed': '削除に失敗しました',
  'pages.app.config.addSuccess': '追加しました',
  'pages.app.config.addFailed': '追加に失敗しました',
  'pages.app.config.saveSuccess': '設定を保存しました',
  'pages.app.config.saveFailed': '保存に失敗しました',
  'pages.app.config.defaultTitle': 'デフォルトモデルの設定',
  'pages.app.config.subtitle': '開始する前にこれらの設定を完了してください',
  'pages.app.config.selectModelPlaceholder': 'モデルを選択してください',
  'pages.app.config.addedModelsTitle': '追加済みのモデル',
  'pages.app.config.hideModels': '表示を減らす',
  'pages.app.config.showMoreModels': 'もっと表示する',
  'pages.app.config.addModelHint': 'モデル（OpenAI, Gemini...）を追加',
  'pages.app.config.addModel': 'モデル追加',
  'pages.app.config.providerLabel': 'プロバイダー',
  'pages.app.config.providerRequired': 'プロバイダーを選択してください',
  'pages.app.config.apiKeyRequired': 'APIキーを入力してください',
  'pages.app.config.editTitle': '{name} の設定を編集',

  // 検索・RAG設定
  'pages.app.searchConfig.name.label': '名称',
  'pages.app.searchConfig.name.placeholder': '名前を入力してください',
  'pages.app.searchConfig.name.required': '名前を入力してください',
  'pages.app.searchConfig.avatar': 'アイコン',
  'pages.app.searchConfig.upload': 'アップロード',
  'pages.app.searchConfig.uploadTip': '最大4MBのファイルをアップロード可能',
  'pages.app.searchConfig.description.label': '説明',
  'pages.app.searchConfig.description.placeholder': '説明文を入力',
  'pages.app.searchConfig.knowledgeBase.label': 'ナレッジベース',
  'pages.app.searchConfig.knowledgeBase.placeholder': '選択してください',
  'pages.app.searchConfig.knowledgeBase.required': 'ナレッジベースを選択してください',
  'pages.app.searchConfig.knowledgeBase.sample2': 'サンプルナレッジベース 2',
  'pages.app.searchConfig.metadata.label': 'メタデータ',
  'pages.app.searchConfig.metadata.tooltip': '検索時に参照するメタデータを選択します',
  'pages.app.searchConfig.metadata.auto': '自動',
  'pages.app.searchConfig.similarityThreshold.label': '類似度しきい値',
  'pages.app.searchConfig.similarityThreshold.tooltip': 'ドキュメントを抽出する際の最小スコア',
  'pages.app.searchConfig.vectorWeight.label': 'ベクトル検索の重み',
  'pages.app.searchConfig.vectorWeight.tooltip': 'ベクトル検索と全文検索の比率を調整します',
  'pages.app.searchConfig.rerankModel': 'Rerankモデル',
  'pages.app.searchConfig.aiSummary': 'AI要約',
  'pages.app.searchConfig.enableRelatedSearch': '関連検索を有効化',
  'pages.app.searchConfig.showMindMap': 'マインドマップを表示',

  // メモリ設定
  'pages.app.memoryConfig.memoryType.label': 'メモリタイプ',
  'pages.app.memoryConfig.memoryType.tooltip': '記憶の保持方法を選択します',
  'pages.app.memoryConfig.memoryType.placeholder': '選択してください',
  'pages.app.memoryConfig.memoryType.required': 'メモリタイプを選択してください',
  'pages.app.memoryConfig.memoryType.raw': 'RAW（生データ）',
  'pages.app.memoryConfig.memoryType.semantic': 'セマンティック',
  'pages.app.memoryConfig.memoryType.episodic': 'エピソード',
  'pages.app.memoryConfig.memoryType.procedural': '手続き型',
  'pages.app.memoryConfig.embeddingModel.label': '埋め込みモデル',
  'pages.app.memoryConfig.embeddingModel.tooltip': 'テキストのベクトル化に使用するモデル',
  'pages.app.memoryConfig.embeddingModel.placeholder': 'モデルを選択',
  'pages.app.memoryConfig.embeddingModel.required': '埋め込みモデルを選択してください',
  'pages.app.memoryConfig.llm.label': 'LLM（大規模言語モデル）',
  'pages.app.memoryConfig.llm.tooltip': 'タスク処理に使用するモデル',
  'pages.app.memoryConfig.llm.placeholder': 'モデルを選択',
  'pages.app.memoryConfig.llm.required': 'LLMを選択してください',

  // チャット設定
  'pages.app.chatConfig.title': 'チャット設定',
  'pages.app.chatConfig.avatar': 'アシスタント画像',
  'pages.app.chatConfig.upload': 'アップロード',
  'pages.app.chatConfig.uploadTip': '最大4MBのファイルをアップロード可能',
  'pages.app.chatConfig.uploadTooLarge': 'ファイルサイズは4MB以下にする必要があります',
  'pages.app.chatConfig.emptyReply.label': '回答不可時の返答',
  'pages.app.chatConfig.emptyReply.tooltip': '答えが見つからない場合に返すメッセージ',
  'pages.app.chatConfig.emptyReply.placeholder': '定型文を入力してください',
  'pages.app.chatConfig.prologue.label': '開始メッセージ',
  'pages.app.chatConfig.prologue.tooltip': '会話開始時の挨拶文',
  'pages.app.chatConfig.prologue.placeholder': 'メッセージを入力してください',
  'pages.app.chatConfig.showCitations': '引用元を表示',
  'pages.app.chatConfig.keywordAnalysis': 'キーワード分析',
  'pages.app.chatConfig.textToSpeech': '音声読み上げ (TTS)',
  'pages.app.chatConfig.directoryEnhancement': 'ディレクトリ構造の強化',
  'pages.app.chatConfig.showCitations.tooltip': '回答の中で参照したソースを表示します',
  'pages.app.chatConfig.keywordAnalysis.tooltip': '質問からキーワードを抽出して分析します',
  'pages.app.chatConfig.textToSpeech.tooltip': '回答を音声で再生します',
  'pages.app.chatConfig.directoryEnhancement.tooltip': '文書の階層構造を考慮して検索精度を高めます',
  'pages.app.chatConfig.knowledgeBase.label': 'ナレッジベース',
  'pages.app.chatConfig.knowledgeBase.tooltip': '関連付けるナレッジベースを選択',
  'pages.app.chatConfig.knowledgeBase.placeholder': '選択...',
  'pages.app.chatConfig.knowledgeBase.sample1': 'サンプル 1',
  'pages.app.chatConfig.knowledgeBase.sample2': 'サンプル 2',
  'pages.app.chatConfig.systemPrompt.label': 'システムプロンプト',
  'pages.app.chatConfig.systemPrompt.placeholder': 'AIの性格や役割、ルールを入力してください',
  'pages.app.chatConfig.similarityThreshold.label': '類似度しきい値',
  'pages.app.chatConfig.similarityThreshold.tooltip': '検索結果として採用する最小スコア',
  'pages.app.chatConfig.vectorWeight.label': 'ベクトルの重み',
  'pages.app.chatConfig.vectorWeight.tooltip': 'ベクトル検索と全文検索の比率',
  'pages.app.chatConfig.multiRoundOptimization.label': 'マルチターン対話最適化',
  'pages.app.chatConfig.multiRoundOptimization.tooltip': '過去のやり取りを分析・要約し、文脈の理解度を高めます',
  'pages.app.chatConfig.useKnowledgeGraph.label': 'ナレッジグラフを使用',
  'pages.app.chatConfig.useKnowledgeGraph.tooltip': '情報をグラフ構造として扱い、推論に活用します',
  'pages.app.chatConfig.reasoning.label': '推論 (Reasoning)',
  'pages.app.chatConfig.reasoning.tooltip': 'ナレッジグラフを用いた推論を行い、回答の正確性を高めます',
  'pages.app.chatConfig.rerankModel.label': 'Rerankモデル',
  'pages.app.chatConfig.rerankModel.tooltip': '検索結果の再ランキング用モデル',
  'pages.app.chatConfig.crossLanguageSearch.label': '多言語検索',
  'pages.app.chatConfig.crossLanguageSearch.tooltip': '言語を跨いだ検索を有効にします',
  'pages.app.chatConfig.crossLanguageSearch.disabled': '無効',
  'pages.app.chatConfig.crossLanguageSearch.enabled': '有効',
  'pages.app.chatConfig.selectPlaceholder': '選択してください',
  'pages.app.chatConfig.topN.label': 'Top N',
  'pages.app.chatConfig.topN.tooltip': '1回の検索で取得するドキュメント断片の最大数',
  'pages.app.chatConfig.variables.label': '変数',
  'pages.app.chatConfig.variables.tooltip': 'プロンプト内で利用可能な動的変数',
  'pages.app.chatConfig.variables.delete': '削除',
  'pages.app.chatConfig.variables.keyword': 'キー名',
  'pages.app.chatConfig.variables.keywordPlaceholder': 'キーを入力',
  'pages.app.chatConfig.variables.optional': 'オプション',
  'pages.app.chatConfig.model.label': 'モデル',
  'pages.app.chatConfig.model.tooltip': '対話に使用するAIモデル',
  'pages.app.chatConfig.model.placeholder': 'モデルを選択',
  'pages.app.chatConfig.model.saveSuccess': '保存に成功しました',
  'pages.app.chatConfig.tavily.label': 'Tavily APIキー',
  'pages.app.chatConfig.tavily.tooltip': 'リアルタイムのWeb検索に使用するAPIキー',
  'pages.app.chatConfig.tavily.placeholder': 'APIキーを入力してください',
  'pages.app.chatConfig.tavily.howToGet': '取得方法はこちら',

  // LLM パラメータ
  'pages.app.chatConfig.temperature.label': '温度 (Temperature)',
  'pages.app.chatConfig.temperature.tooltip': '回答のランダム性を制御します。低いと安定、高いと創造的になります',
  'pages.app.chatConfig.topP.label': 'Top P',
  'pages.app.chatConfig.topP.tooltip': '核サンプリングのしきい値',
  'pages.app.chatConfig.presencePenalty.label': '存在ペナルティ',
  'pages.app.chatConfig.presencePenalty.tooltip': '新しい話題を導入しやすくなるように制御します',
  'pages.app.chatConfig.frequencyPenalty.label': '頻度ペナルティ',
  'pages.app.chatConfig.frequencyPenalty.tooltip': '同じ言葉の繰り返しを抑制します',
  'pages.app.chatConfig.maxTokens.label': '最大トークン数',
  'pages.app.chatConfig.maxTokens.tooltip': '生成される回答の最大長',
  'pages.app.chatConfig.creativity.label': '自由度',
  'pages.app.chatConfig.creativity.precise': '厳密',
  'pages.app.chatConfig.creativity.balanced': '標準',
  'pages.app.chatConfig.creativity.creative': '独創的',
};
